import { render, staticRenderFns } from "./TextFieldForm.vue?vue&type=template&id=ddafedbe&"
import script from "./TextFieldForm.vue?vue&type=script&lang=js&"
export * from "./TextFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldForm.vue?vue&type=style&index=0&id=ddafedbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports